import React from 'react';
import moment, { Moment } from 'moment';
import { BsCalendar, BsClock } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { format, parseISO } from 'date-fns';

import { Box } from '@qwealth/qcore';

import { ENG_DATE_FORMAT } from 'data/refData/time';

const callDateFormat = 'eee. MMM do, yyyy';

interface PreviewDetailsSectionProps {
  isSmallCard: boolean;
  type: string;
  createdBy: string;
  created: string;
  emailTo?: string;
  emailFrom?: string;
  syncDate?: string;
  eventStart?: Moment;
  eventEnd?: Moment;
  meetingDate?: string;
}

const PreviewDetailsSection: React.FC<PreviewDetailsSectionProps> = ({
  isSmallCard,
  type,
  createdBy,
  created,
  emailTo,
  emailFrom,
  syncDate,
  eventStart,
  eventEnd,
  meetingDate,
}) => {
  const navigate = useNavigate();

  return (
    <Box display="flex" flexDirection="row" justifyContent="space-between" fontSize="small">
      <Box display="flex" flexDirection="column" paddingLeft="small" color="dark">
        {type !== 'Email' && type !== 'Event' && (
          <Box display="flex" flexDirection="row" gap="default">
            <Box fontWeight="bold">Created By: </Box>
            <Box>{createdBy}</Box>
          </Box>
        )}

        {type === 'Event' && eventStart && eventEnd && (
          <Box display="flex" flexDirection="row" gap="default">
            <Box display="flex" gap="small" alignItems="center">
              <BsCalendar />
              <Box>{moment(eventStart).format(ENG_DATE_FORMAT + ', h:mm A')}</Box>
            </Box>
            <Box display="flex" gap="small" alignItems="center">
              <BsClock />
              <Box>
                {moment(eventStart).format('LT')} - {moment(eventEnd).format('LT')}
              </Box>
            </Box>
          </Box>
        )}

        {type === 'Email' && (
          <Box display="flex" flexDirection="column">
            <Box display="flex" flexDirection="row" gap="default">
              <Box fontWeight="bold">To: </Box>
              <Box>{emailTo}</Box>
            </Box>
            <Box display="flex" flexDirection="row" gap="default">
              <Box fontWeight="bold">From: </Box>
              <Box>{emailFrom}</Box>
            </Box>
          </Box>
        )}

        {isSmallCard && (
          <Box display="flex" flexDirection="column">
            {type === 'QNote' && (
              <Box display="flex" flexDirection="row" gap="default">
                <Box fontWeight="bold">Created:</Box>
                <Box>{moment(created).format(ENG_DATE_FORMAT)} </Box>
              </Box>
            )}

            {syncDate !== '' && (
              <Box display="flex" flexDirection="row" gap="default" color="gray.1">
                <Box fontWeight="bold">Last Sync:</Box>
                <Box>{moment(syncDate).format(ENG_DATE_FORMAT + ', h:mm A')} </Box>
              </Box>
            )}

            {type === 'Email' && (
              <Box display="flex" flexDirection="row" gap="default">
                <Box fontWeight="bold">Send Date:</Box>
                <Box>{moment(created).format(ENG_DATE_FORMAT + ', h:mm A')} </Box>
              </Box>
            )}

            {type === 'Call Log' && (
              <Box display="flex" flexDirection="row" gap="default">
                <Box fontWeight="bold">Call Date:</Box>
                <Box>{meetingDate ? format(parseISO(meetingDate), callDateFormat) : ''}</Box>
              </Box>
            )}
          </Box>
        )}
      </Box>

      {!isSmallCard && (
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap="default" alignItems="end" marginRight="small" color="dark">
            {type === 'QNote' && (
              <>
                <Box fontWeight="bold">Created:</Box>
                <Box>{moment(created).format(ENG_DATE_FORMAT)} </Box>
              </>
            )}

            {type === 'Email' && (
              <>
                <Box fontWeight="bold">Send Date:</Box>
                <Box>{moment(created).format(ENG_DATE_FORMAT + ', h:mm A')} </Box>
              </>
            )}

            {type === 'Call Log' && (
              <>
                <Box fontWeight="bold">Call Date:</Box>
                <Box>{meetingDate ? format(parseISO(meetingDate), callDateFormat) : ''}</Box>
              </>
            )}
          </Box>
          {syncDate !== '' && (
            <Box display="flex" flexDirection="row" gap="default" alignItems="end" marginRight="small" color="gray.1">
              <Box fontWeight="bold">Last Sync:</Box>
              <Box>{moment(syncDate).format(ENG_DATE_FORMAT + ', h:mm A')} </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default PreviewDetailsSection;
